import { Outlet } from "react-router-dom";

const AppLayoutsPublic = () => {
  return (
    <div className="h-screen flex flex-col bg-white text-gray-900 dark:bg-slate-950 dark:text-white overflow-hidden">
      <main className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
};

export default AppLayoutsPublic;
